// This file is used to update the global data on the site.
// To reduce the amount of API calls, we should bundle the data together, and then update the stores.

// Stores
import { useAnnouncementStore } from '~/stores/announcement';
import { useAirtableStore } from '@/stores/airtable';
import { useHeaderStore } from '@/stores/header';
import { useFooterStore } from '@/stores/footer';
import { useSocialStore } from '@/stores/social';


export const updateGlobals = async (global, airtable) => {
    if (global?.data) {
        useHeaderStore().init({
            logo: {
                url: global.data.header.logo,
                alt: global.data.header.alt,
            },
            menu: global.data.header.menu,
        });

        useAnnouncementStore().init({
            announcementHtml: global.data.announcementBannerText,
        });

        useFooterStore().init({
            menu: global.data.footerData.footerLinks,
            cta: global.data.footerData.cta,
            androidAppUrl: global.data.footerData.androidAppUrl,
            appleAppUrl: global.data.footerData.appleAppUrl,
            newsletter: global.data.newsletter,
            links: global.data.footerData.footerLinks
        });

        useSocialStore().init({
            socials: global.data.socials,
        });
    }

    // Update the Airtable store
    if (airtable?.data) {
        useAirtableStore().init({
            sessions: airtable.data.sessions,
            speakers: airtable.data.speakers,
            sponsors: airtable.data.sponsors,
            tags: airtable.data.tags,
            targetedAgendas: airtable.data.targetedAgendas,
        });
    }

    return global;
};
